<div class="container hide-scrollbar">
  <br /> 
  <h1>Horizontal Vessel</h1>
  <br/>
  <div style="margin-top: 10px;">
    <form [formGroup] ="horizontalform" (ngSubmit)="onSubmit()" class="form-horizontal">
        <div class="row form-group" >
          <div class="col-md-6">
            <div class ="row">
              <div class="col-md-12">
                <img src= '/assets/images/HorizontalVesselBG.jpg' class="center-block img-thumbnail"/>
              </div>
            </div>
            <div class ="row float-left">
              <div  style="margin-top:230px" class="col-md-12">
                <br />
                <button type="button" name="nBtn2" id="Bid2"class="btn btn-primary btn-custom no-arrow" (click)="closeDialog()"><span class="icon-chevron-left"></span>&nbsp;Back</button>
                </div>
              </div>
          </div>
          <div class="col-md-3">
           
            <div class ="row">
                <div class="col-md-12">
                  <!-- <label class="control-label" style="color: lightgrey;">Minimum Horizontal Distance of the Flaw, Ld
                    &nbsp;<span *ngIf="this.intUnit === 0">(inch) *</span>
                          <span *ngIf="this.intUnit === 1">(mm) *</span></label>  -->
                          <label  class="control-label">Outside Diameter of Cylindrical or Conical Shell Section, OD 
                            &nbsp;<span *ngIf="this.intUnit === 0">(inch) <span style="color:red"> *</span></span>
                            <span *ngIf="this.intUnit === 1">(mm) <span style="color:red"> *</span></span>
                          </label> 
                </div>
             </div>
            <!-- <br /> -->
            <br />
            <div class ="row">
              <div class="col-md-12">
                <!-- <label  class="control-label">Outside Diameter of Cylindrical or Conical Shell Section, OD 
                  &nbsp;<span *ngIf="this.intUnit === 0">(inch) *</span>
                  <span *ngIf="this.intUnit === 1">(mm) *</span>
                </label>   -->
                <br />
                <label class="control-label">Distance between saddle supports Lss 
                  &nbsp;<span *ngIf="this.intUnit === 0">(inch) <span style="color:red"> *</span></span>
                        <span *ngIf="this.intUnit === 1">(mm) <span style="color:red"> *</span></span></label>  
              </div>
            </div>
            <br />
            <br />
            <div class ="row">
              <div class="col-md-12">
                <!-- <label class="control-label">Distance between saddle supports Lss 
                  &nbsp;<span *ngIf="this.intUnit === 0">(inch) *</span>
                        <span *ngIf="this.intUnit === 1">(mm) *</span></label>   -->
                        <label class="control-label" style="color: lightgrey;">Location of the Flaw *
                        </label> 
              </div>
            </div>
            <br />
            <br />
            <div class ="row">
              <div class="col-md-12">
                <!-- <label class="control-label" style="color: lightgrey;">Location of the Flaw *
                </label>   -->
                <label class="control-label" style="color: lightgrey;">Minimum Horizontal Distance of the Flaw, Ld
                  &nbsp;<span *ngIf="this.intUnit === 0">(inch) *</span>
                        <span *ngIf="this.intUnit === 1">(mm) *</span></label>
              </div>
            </div>

           
            <div class ="row" >
              <div style="height: 80px"  class="col-md-12" [style.font-color]="myColor">
                <!-- <br />
                <br /> -->
                <br />
                <br />
                <!-- <h4 style="color: myColor;">{{ Result }}</h4>  -->
                <p style="color: {{myColor}};">{{ Result }}</p>
               </div>
            </div>

            <div class ="row">
              <div class="col-md-12" style="margin-top:110px">
                <label class="control-label" style="font-size: 12px; color: red;">* Screening based on Location of the Flaw will be available in a future version.
                </label>  
              </div>
            </div>
            
          </div>
          <div class="col-md-3">
            <div class ="row">
              <div class="col-md-12">
                <!-- <input  class="form-control border-secondary" [readonly]="true"  type="number"  formControlName ="input1" required/> -->
                <input class="form-control border-secondary" type="number"  formControlName="input2" required/>
              </div>
            </div>
            <br />
            <br />
            <div class ="row">
              <div class="col-md-12">
                <!-- <input class="form-control border-secondary" type="number"  formControlName="input2" required/> -->
                <input class="form-control border-secondary" type="number"  formControlName="input3" required/>
              </div>
            </div>
            <br />
            <br />
            <div class ="row">
              <div class="col-md-12">
                <!-- <input class="form-control border-secondary" type="number"  formControlName="input3" required/> -->
                <select name="LocationFlaw" id="LocationFlaw" class="form-control border-secondary" [disabled] ="locFlaw" required>
                  <option value="-1"></option>
                  <option value="volvo">Between Saddle Supports</option>
                  <option value="saab">Overhang</option>
                </select>
              </div>
            </div>
            <br />
            <br />
            <div class ="row">
              <div class="col-md-12">
                <!-- <select name="LocationFlaw" id="LocationFlaw" class="form-control border-secondary" [disabled] ="locFlaw" required>
                  <option value="-1"></option>
                  <option value="volvo">Between Saddle Supports</option>
                  <option value="saab">Overhang</option>
                </select> -->
                <input  class="form-control border-secondary" [readonly]="true"  type="number"  formControlName ="input1" required/>
              </div>
            </div>

            <div class ="row float-right">
              <div class="col-md-12">
                <br />
                <br />
                <br />
                <br />
                <button id="Bid1" name="nBtn1" type="submit" class="btn btn-primary btn-custom no-arrow" (click)="onSubmit()">Calculate&nbsp;<span class="icon-chevron-right"></span></button>
              </div>
            </div>
            <div class ="row float-right">             
              <div class="col-md-12" >               
                <br />
                <div style="margin-top:80px"></div>
                <button type="button" name="nBtn3" id="Bid3" [disabled]="isDisabled" class="btn btn-primary btn-custom no-arrow" (click)="BacktoALS()">Next&nbsp;<span class="icon-chevron-right"></span></button> 
              </div>
            </div>
          </div>         
        </div>

      </form>    
  </div>
</div>

        
     
     
     
     
     
     
     
     
     
     
     
     
     
     
